import type { CamelCasedPropertiesDeep } from 'type-fest';

import camelCaseKeysDeep from './camelCaseKeys';

export const responseDataToCamelCase = <T>(response: { data: T }): { data: CamelCasedPropertiesDeep<T> } => {
  return {
    ...response,
    data: camelCaseKeysDeep(response.data),
  };
};
